import React, { useContext, useCallback, useMemo } from 'react';

import RouteContext from 'src/routes/context';

import SidebarFilter from './sidebar-filter';
import { FilterMobile } from './filter-mobile';
import { FeaturedFilters } from '../featured-filters';

import {
  ProductCollectionFilterContext,
  useTrackClearFilter,
} from '../../filter-tracking';

import {
  FilterSlice,
  ProductCollectionFilter,
  ProductCollectionNameSearchFilter,
} from 'src/types';
import { ProductCollectionNonNameSearchFilter } from './types';

import * as S from './styles';
import { DesktopOnly, MediumDown } from 'src/ui/block';

type Props = Pick<FilterSlice, 'id' | 'sections' | 'filters' | 'productsCount'>;

const isNameSearchFilter = (
  filter: ProductCollectionFilter
): filter is ProductCollectionNameSearchFilter =>
  'type' in filter && filter.type === 'name-search';

const Filter = ({ sections, filters, productsCount }: Props) => {
  const { dispatch } = useContext(RouteContext);

  const trackClearFilter = useTrackClearFilter();

  const mainFiltersTEMpNAME = useMemo(
    () =>
      filters.filter(
        (filter): filter is ProductCollectionNonNameSearchFilter =>
          !isNameSearchFilter(filter)
      ),
    [filters]
  );

  const featuredFilterSections = useMemo(
    () => sections.filter(item => item.featured),
    [sections]
  );

  const clearFilter = useCallback(
    (property?: string) => {
      if (property) {
        trackClearFilter(property);
      }
      dispatch({ type: 'FILTER_REMOVE', property });
    },
    [dispatch, trackClearFilter]
  );

  return sections.length === 0 ? null : (
    <S.Wrapper>
      <MediumDown>
        <FilterMobile
          appliedFilters={mainFiltersTEMpNAME}
          clearFilter={clearFilter}
          filters={filters}
          productsCount={productsCount}
          sections={sections}
        />
      </MediumDown>

      <DesktopOnly>
        <div>
          <ProductCollectionFilterContext.Provider
            value={{ filterLayout: 'quick-filter' }}
          >
            <FeaturedFilters
              filters={mainFiltersTEMpNAME}
              sections={featuredFilterSections}
              clearFilter={clearFilter}
            />
          </ProductCollectionFilterContext.Provider>
        </div>
      </DesktopOnly>

      <ProductCollectionFilterContext.Provider
        value={{ filterLayout: 'sidebar-filters' }}
      >
        <SidebarFilter
          key="sidebar"
          sections={sections}
          filters={mainFiltersTEMpNAME}
        />
      </ProductCollectionFilterContext.Provider>
    </S.Wrapper>
  );
};

export default Filter;
